<!-- Clinical registry table. Pagination, row-action menu and loading spinner are OneVedAI UI library parts;
     look & feel is driven by the central theme (src/theme). -->
<div class="generic-table-container">
  <div class="table-wrap">
    <table class="generic-table">
      <thead>
        <tr>
          @for (column of visibleColumns; track trackColumn($index, column)) {
            <th
              [style.width]="column.width || null"
              [class.sortable]="column.sortable && settingsContext.gridSettings.enableSorting"
              [attr.aria-sort]="sortColumn === column.id ? (sortDirection === 'asc' ? 'ascending' : 'descending') : null"
              (click)="handleSort(column)"
            >
              <div class="header-content" [class]="resolveAlignClass(column)">
                <span>{{ column.label }}</span>
                @if (settingsContext.gridSettings.enableSorting && column.sortable && sortColumn === column.id) {
                  <span class="material-symbols-outlined sort-icon">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span>
                }
              </div>
            </th>
          }
          @if (actions.length > 0) {
            <th class="action-col">Actions</th>
          }
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          @for (_ of skeletonRows; track $index) {
            <tr class="skeleton-row" aria-hidden="true">
              @for (column of visibleColumns; track trackColumn($index, column)) {
                <td><span class="skeleton-bar"></span></td>
              }
              @if (actions.length > 0) {
                <td class="action-col"><span class="skeleton-bar short"></span></td>
              }
            </tr>
          }
        }
        @for (row of loading ? [] : paginatedData; track $index) {
          <tr [class.clickable]="clickableRows" [class.active]="clickableRows && row === activeRow" (click)="onRowClick(row, $event)">
            @for (column of visibleColumns; track trackColumn($index, column)) {
              <td [style.width]="column.width || null">
                <div class="cell-content" [class]="resolveAlignClass(column)" [class.contact-cell]="column.id === 'contact'">
                  @if (isMultiLineCell(row, column)) {
                    <div class="cell-stack">
                      @for (line of getCellLines(row, column); track $index) {
                        <div class="cell-line">
                          <span class="cell-text" [class.is-code]="column.copyable">{{ line }}</span>
                          @if (column.copyable && line !== '-') {
                            <button type="button" class="copy-btn" aria-label="Copy value" (click)="copyValue(line, $event)">
                              <span class="material-symbols-outlined">content_copy</span>
                            </button>
                          }
                        </div>
                      }
                    </div>
                  } @else if (getBadgeValues(row, column).length > 0) {
                    <div class="badge-group">
                      @for (badgeValue of getBadgeValues(row, column); track $index) {
                        <span
                          class="table-badge"
                          [class]="'table-badge variant-' + (badgeValue.variant || 'default')"
                          [ngStyle]="badgeValue.style || null"
                          >{{ badgeValue.text }}</span
                        >
                      }
                    </div>
                  } @else {
                    <span class="cell-text" [class.is-code]="column.copyable">{{ getCellValue(row, column) ?? '-' }}</span>
                    @if (column.copyable) {
                      <button type="button" class="copy-btn" aria-label="Copy value" (click)="copyValue(getCellValue(row, column), $event)">
                        <span class="material-symbols-outlined">content_copy</span>
                      </button>
                    }
                  }
                </div>
              </td>
            }
            @if (actions.length > 0) {
              <td class="action-col">
                <onevedai-menu align="end" (ovSelect)="onActionSelect($event, row)">
                  <button slot="trigger" type="button" class="row-menu-btn" aria-label="Open row actions">
                    <span class="material-symbols-outlined">more_vert</span>
                  </button>
                  @for (action of actions; track $index) {
                    @if (!isActionHidden(action, row)) {
                      <onevedai-menu-item [value]="'' + $index" [disabled]="isActionDisabled(action, row)">{{ getActionLabel(action, row) }}</onevedai-menu-item>
                    }
                  }
                </onevedai-menu>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (loading) {
    <span class="sr-only" role="status">Loading data...</span>
  } @else if (paginatedData.length === 0) {
    <div class="table-state">
      <span class="material-symbols-outlined">inbox</span>
      <span>{{ emptyMessage }}</span>
    </div>
  }

  @if (!loading && isPaginated && sortedData.length > 0) {
    <div class="table-footer">
      <span class="toolbar-label"
        >Showing {{ (page - 1) * pageSize + 1 }} - {{ Math.min(page * pageSize, sortedData.length) }} of {{ sortedData.length }}</span
      >
      <onevedai-paginator
        [length]="sortedData.length"
        [pageSize]="pageSize"
        [pageIndex]="page - 1"
        [pageSizeOptions]="pageSizeOptions"
        [hidePageSize]="!settingsContext.gridSettings.allowPageSizeSelection"
        (ovPageChange)="onPaginatorChange($event)"
      ></onevedai-paginator>
    </div>
  }
</div>
